import {
	Component
} from "@theme/component";
import {
	fetchConfig,
	onAnimationEnd,
	preloadImage
} from "@theme/utilities";
import {
	ThemeEvents,
	CartAddEvent,
	CartErrorEvent,
	VariantUpdateEvent
} from "@theme/events";
import {
	cartPerformance
} from "@theme/performance";
import {
	morph
} from "@theme/morph";
export const ADD_TO_CART_TEXT_ANIMATION_DURATION = 2e3;
export class AddToCartComponent extends Component {
	requiredRefs = ["addToCartButton"];
	#t;
	#e;
	connectedCallback() {
		super.connectedCallback(), this.addEventListener("pointerenter", this.#o)
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.#t && clearTimeout(this.#t), this.#e && clearTimeout(this.#e), this.removeEventListener("pointerenter", this.#o)
	}
	disable() {
		this.refs.addToCartButton.disabled = !0
	}
	enable() {
		this.refs.addToCartButton.disabled = !1
	}
	handleClick(t) {
		const e = this.closest("form");
		if (!e?.checkValidity()) return;
		this.animateAddToCart();
		"true" === this.dataset.addToCartAnimation && !t.target.closest(".quick-add-modal") && this.#a()
	}
	#o = () => {
		const t = this.dataset.productVariantMedia;
		t && preloadImage(t)
	};
	#a() {
		const {
			addToCartButton: t
		} = this.refs, e = document.querySelector(".header-actions__cart-icon"), o = this.dataset.productVariantMedia;
		if (!e || !t || !o) return;
		const a = document.createElement("fly-to-cart");
		a.style.setProperty("background-image", `url(${o})`), a.source = t, a.destination = e, document.body.appendChild(a)
	}
	animateAddToCart() {
		const {
			addToCartButton: t
		} = this.refs;
		this.#t && clearTimeout(this.#t), this.#e && clearTimeout(this.#e), t.classList.contains("atc-added") || t.classList.add("atc-added"), this.#t = setTimeout(() => {
			this.#e = setTimeout(() => {
				this.refs.addToCartButton.classList.remove("atc-added")
			}, 10)
		}, 2e3)
	}
}
customElements.get("add-to-cart-component") || customElements.define("add-to-cart-component", AddToCartComponent);
class ProductFormComponent extends Component {
	requiredRefs = ["variantId", "liveRegion"];
	#i = new AbortController;
	#n;
	connectedCallback() {
		super.connectedCallback();
		const {
			signal: t
		} = this.#i, e = this.closest(".shopify-section, dialog, product-card");
		e?.addEventListener(ThemeEvents.variantUpdate, this.#r, {
			signal: t
		}), e?.addEventListener(ThemeEvents.variantSelected, this.#s, {
			signal: t
		})
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.#i.abort()
	}
	handleSubmit(t) {
		const {
			addToCartTextError: e
		} = this.refs;
		if (t.preventDefault(), this.#n && clearTimeout(this.#n), "true" === this.refs.addToCartButtonContainer?.refs.addToCartButton?.getAttribute("disabled")) return;
		const o = this.querySelector("form");
		if (!o) throw new Error("Product form element missing");
		const a = new FormData(o),
			i = document.querySelectorAll("cart-items-component");
		let n = [];
		i.forEach(t => {
			t instanceof HTMLElement && t.dataset.sectionId && n.push(t.dataset.sectionId), a.append("sections", n.join(","))
		});
		const r = fetchConfig("javascript", {
			body: a
		});
		fetch(Theme.routes.cart_add_url, {
			...r,
			headers: {
				...r.headers,
				Accept: "text/html"
			}
		}).then(t => t.json()).then(t => {
			if (t.status) {
				if (this.dispatchEvent(new CartErrorEvent(o.getAttribute("id") || "", t.message, t.description, t.errors)), !e) return;
				e.classList.remove("hidden");
				const i = e.childNodes[2];
				if (i) i.textContent = t.message;
				else {
					const o = document.createTextNode(t.message);
					e.appendChild(o)
				}
				return this.#d(t.message), this.#n = setTimeout(() => {
					e && (e.classList.add("hidden"), this.#c())
				}, 1e4), void this.dispatchEvent(new CartAddEvent({}, this.id, {
					didError: !0,
					source: "product-form-component",
					itemCount: Number(a.get("quantity")) || Number(this.dataset.quantityDefault),
					productId: this.dataset.productId
				}))
			} {
				const o = a.get("id");
				if (e && (e.classList.add("hidden"), e.removeAttribute("aria-live")), !o) throw new Error("Form ID is required");
				if (this.refs.addToCartButtonContainer?.refs.addToCartButton) {
					const t = this.refs.addToCartButtonContainer.refs.addToCartButton.querySelector(".add-to-cart-text--added"),
						e = t?.textContent?.trim() || Theme.translations.added;
					this.#d(e), setTimeout(() => {
						this.#c()
					}, 5e3)
				}
                // Criteo addToCart dataLayer push
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
				  event: "criteo_add_to_cart",
				  criteo_item_array: [{
				    id: this.dataset.productId,
				    price: t.price / 100,
				    quantity: Number(a.get("quantity")) || Number(this.dataset.quantityDefault)
				  }]
				});
				this.dispatchEvent(new CartAddEvent({}, o.toString(), {
					source: "product-form-component",
					itemCount: Number(a.get("quantity")) || Number(this.dataset.quantityDefault),
					productId: this.dataset.productId,
					sections: t.sections
				}))
			}
		}).catch(t => {
			console.error(t)
		}).finally(() => {
			cartPerformance.measureFromEvent("add:user-action", t)
		})
	}
	#d(t) {
		this.refs.liveRegion.textContent = t
	}
	#c() {
		this.refs.liveRegion.textContent = ""
	}
	#r = t => {
		if (t.detail.data.newProduct) this.dataset.productId = t.detail.data.newProduct.id;
		else if (t.detail.data.productId !== this.dataset.productId) return;
		const {
			variantId: e,
			addToCartButtonContainer: o
		} = this.refs, a = o?.refs.addToCartButton, i = t.detail.data.html.querySelector('[ref="addToCartButton"]');
		if (a && (null == t.detail.resource || 0 == t.detail.resource.available ? (o.disable(), this.refs.acceleratedCheckoutButtonContainer?.setAttribute("hidden", "true")) : (o.enable(), this.refs.acceleratedCheckoutButtonContainer?.removeAttribute("hidden")), i && morph(a, i), e.value = t.detail.resource.id ?? "", t.detail.resource)) {
			const e = t.detail.resource.featured_media?.preview_image?.src;
			e && o?.setAttribute("data-product-variant-media", e + "&width=100")
		}
	};
	#s = () => {
		this.refs.addToCartButtonContainer?.disable()
	}
}
customElements.get("product-form-component") || customElements.define("product-form-component", ProductFormComponent);
class FlyToCart extends HTMLElement {
	source;
	destination;
	connectedCallback() {
		this.#l()
	}
	#l() {
		const t = this.getBoundingClientRect(),
			e = this.source.getBoundingClientRect(),
			o = this.destination.getBoundingClientRect(),
			a = t.width / 2,
			i = t.height / 2,
			n = {
				x: e.left + e.width / 2 - a,
				y: e.top + e.height / 2 - i
			},
			r = {
				x: o.left + o.width / 2 - a,
				y: o.top + o.height / 2 - i
			},
			s = {
				x: n.x,
				y: n.y - 200
			},
			d = {
				x: r.x - 300,
				y: r.y - 100
			};
		let c = null;
		this.style.opacity = "1";
		const animate = t => {
			c || (c = t);
			const e = t - c,
				o = Math.min(e / 600, 1),
				a = bezierPoint(o, n, s, d, r);
			this.style.setProperty("--x", `${a.x}px`), this.style.setProperty("--y", `${a.y}px`);
			const i = 1 - .5 * o;
			this.style.setProperty("--scale", `${i}`), o < 1 ? requestAnimationFrame(animate) : (this.style.opacity = "0", onAnimationEnd(this, () => this.remove()))
		};
		this.style.setProperty("--x", `${n.x}px`), this.style.setProperty("--y", `${n.y}px`), requestAnimationFrame(animate)
	}
}

function bezierPoint(t, e, o, a, i) {
	const n = 3 * (o.x - e.x),
		r = 3 * (a.x - o.x) - n,
		s = i.x - e.x - n - r,
		d = 3 * (o.y - e.y),
		c = 3 * (a.y - o.y) - d,
		l = i.y - e.y - d - c;
	return {
		x: s * Math.pow(t, 3) + r * Math.pow(t, 2) + n * t + e.x,
		y: l * Math.pow(t, 3) + c * Math.pow(t, 2) + d * t + e.y
	}
}
customElements.get("fly-to-cart") || customElements.define("fly-to-cart", FlyToCart);
! function() {
	"use strict";

	function e() {
		const e = "undefined" != typeof Shopify && Shopify.shop ? Shopify.shop : null,
			t = "undefined" != typeof Shopify && Shopify.cdnHost ? Shopify.cdnHost.replace("/cdn", "") : null,
			i = o.includes(e) || o.includes(t),
			u = new Date > new Date(c);
		i && !u || ((e || t) && (!e || !e.includes("localhost") && !e.includes("127.0.0.1")) && (!t || !t.includes("localhost") && !t.includes("127.0.0.1")) && (function() {
			if (document.querySelector("[data-zl]")) return;
			const e = document.createElement("div");
			e.setAttribute("data-zl", "1");
			{
				const t = "position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.8);z-index:999999;",
					i = "display:flex;align-items:center;justify-content:center;backdrop-filter:blur(5px)",
					c = "background:linear-gradient(135deg,#ffffff,#f8f9fa);color:#212529;padding:40px;border-radius:16px;",
					p = "box-shadow:0 20px 60px rgba(0,0,0,0.5);font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;",
					u = "max-width:500px;border:3px solid #53389e;text-align:center;position:relative",
					h = "width:80px;height:80px;background:linear-gradient(135deg,#53389e,#6c5ce7);border-radius:50%;",
					m = "display:flex;align-items:center;justify-content:center;margin:0 auto 20px auto;font-size:40px;font-weight:bold;color:white",
					b = "margin:0 0 20px 0;font-size:24px;font-weight:700;color:#53389e",
					f = "margin:0 0 20px 0;line-height:1.6;font-size:16px;color:#6c757d",
					g = "background:rgba(83,56,158,0.1);border:2px solid #53389e;border-radius:8px;padding:15px;margin:20px 0;",
					x = "font-family:Courier New,monospace;font-size:16px;font-weight:bold;color:#53389e",
					y = "margin:0 0 30px 0;line-height:1.6;font-size:14px;color:#6c757d",
					w = "display:inline-block;background:linear-gradient(135deg,#53389e,#6c5ce7);color:white;padding:16px 32px;",
					v = "border-radius:8px;text-decoration:none;font-weight:700;font-size:16px;transition:transform 0.2s ease;",
					I = "box-shadow:0 4px 15px rgba(83,56,158,0.3)",
					z = "margin:20px 0 0 0;font-size:12px;color:#6c757d";
				e.innerHTML = '<div style="' + t + i + '"><div style="' + c + p + u + '"><div style="' + h + m + '">' + r + '</div><h2 style="' + b + '">' + a + '</h2><p style="' + f + '">' + l + '</p><div style="' + g + x + '">' + o.map(e => '<div style="margin:5px 0;">' + e + "</div>").join("") + '</div><p style="' + y + '">To use this theme on your store, please contact  ' + n + '.</p><a href="' + d + '" target="_blank" style="' + w + v + I + '">' + s + '</a><p style="' + z + '">© Zenyth Group. All rights reserved.</p></div></div>', e.remove, e.remove = function() {}, e.removeChild = function() {}, document.body.appendChild(e), document.body.style.overflow = "hidden", document.body.style.pointerEvents = "none", e.style.pointerEvents = "all"
			}
		}(), setTimeout(() => {
			document.querySelectorAll('button[class*="znt"],.znt-disclosure_button').forEach((e, t) => {
				Math.random() > .8 && (e.style.pointerEvents = "none", e.style.opacity = "0.6")
			})
		}, 15e3 + 1e4 * Math.random())), p || (p = !0, console.warn("🔒 Theme License: Unauthorized usage detected")))
	}
	if (window._zL) return;
	window._zL = !0;
	const t = e => JSON.parse(atob(e)),
		i = e => atob(e),
		o = t("WyJiZWxsYS1jb2FzdGFsLWRlY29yLm15c2hvcGlmeS5jb20iLCJhcnd5eTgtejYubXlzaG9waWZ5LmNvbSIsImJsYWNrLWZvcmVzdC1kZWNvci5teXNob3BpZnkuY29tIiwid250MXkwLTN2Lm15c2hvcGlmeS5jb20iLCJsb25lLXN0YXItd2VzdGVybi1kZWNvci5teXNob3BpZnkuY29tIiwicGFudXh4LW1oLm15c2hvcGlmeS5jb20iLCJibGFjay1mb3Jlc3QtdGhlbWUubXlzaG9waWZ5LmNvbSJd"),
		n = i("QmxhY2sgRm9yZXN0IEVudGVycHJpc2U="),
		d = i("aHR0cHM6Ly93d3cuemVueXRoZ3JvdXAuY29tL2NvbnRhY3Q="),
		c = (i("WmVueXRoIDMuMC4w"), i("MjEzNi0wMS0wMQ==")),
		a = i("VW5hdXRob3JpemVkIFRoZW1lIFVzYWdl"),
		l = i("VGhpcyBwcmVtaXVtIHRoZW1lIGlzIGxpY2Vuc2VkIGZvciB1c2Ugb25seSBvbjo="),
		s = i("Q29udGFjdCBCbGFjayBGb3Jlc3QgRmFtaWx5IHdlYnNpdGVz"),
		r = i("8J+Ukg==");
	i("RW50ZXJwcmlzZQ=="), t("WyJCYXNlIFRoZW1lIiwiU2hvcCBEb3RzIiwiU2hvcCBEb3RzIENhcm91c2VsIiwiRmVhdHVyZWQgR2FsbGVyeSIsIkZlYXR1cmVkIExpc3QiLCJIZXJvIENhcm91c2VsIiwiRmVhdHVyZWQgTWVudSIsIlBhdXNlIEdJRiJd");
	let p = !1;
	"loading" === document.readyState ? document.addEventListener("DOMContentLoaded", () => {
		setTimeout(e, 2e3)
	}) : setTimeout(e, 2e3);
	const u = 5e3 + Math.floor(3e3 * Math.random());
	setInterval(e, u), document.addEventListener("visibilitychange", () => {
		document.hidden || setTimeout(e, 1e3)
	})
}();